module.exports = __webpack_public_path__ + "media/application/images/2018/star-grey-fc0d88a82d87ebb08db0a04022265341.svg";